import React, { useEffect, useState } from "react";
import { Grid, Paper, useMediaQuery, Box, Modal, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import {
  CycleCount_print_API,
} from "../../../Server/ApiV2";
import { CyclecountRo } from "../../../Redux/roStore";

const PrintModal = ({
  open = false,
  fCloseModal = () => { },
  xTitle = "Variance",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const [Wmsrows, setWmsrows] = useState([]);
  const [ERProws, setERProws] = useState([]);
  const reset = () => {
    setERProws([]);
    setWmsrows([]);
  }

  const columnsWms = [
    {
      field: "id",
      headerName: "Sr.No",
      width: 100,
      hide: true
    },
    {
      field: "BinName",
      headerName: "Bin Name",
      width: 100,
    },
    {
      field: "ItemCode",
      headerName: "Item Code",
      hide: true,
    },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 180,
    },
    {
      field: "CardID",
      headerName: "Card ID",
      width: 150,
    },
    {
      field: "BarCode",
      headerName: "Barcode",
      width: 150,
    },
    {
      field: "SuppRefNo1",
      headerName: "SuppRef.No1",
      width: 90
    },
    {
      field: "PhyQty",
      headerName: "Physical.Qty",
      width: 90
    },
    {
      field: "BookQty",
      headerName: "Book.Qty",
      width: 90
    },
    {
      field: "VarQty",
      headerName: "Variance.Qty",
      width: 90
    },
  ];

  const columnsErp = [
    {
      field: "id",
      headerName: "Sr.No",
      width: 100,
      hide: true
    },
    {
      field: "ItmCd",
      headerName: "ItemCode",
    },
    {
      field: "VarianceQty",
      headerName: "Variance Qty",
    },
    {
      field: "unit",
      headerName: "Unit",
    },
    {
      field: "Cost",
      headerName: "Cost",
    },
    {
      field: "NetAmount",
      headerName: "Net Amount",
    },
  ];

  const handleLoadDefault = async () => {
    const { HeadObj } = CyclecountRo();
    const payload = {
      "v_A_SheetId": HeadObj.SheetNo
    };
    let resp = await CycleCount_print_API(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      let respERPData = resp?.data?.ERPVariance;
      respERPData = respERPData?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      let respWMSData = resp?.data?.Variance;
      respWMSData = respWMSData?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setERProws(respERPData);
      setWmsrows(respWMSData);
    } else {
      reset()
    }
  };

  useEffect(() => {
    if (open) {
      handleLoadDefault();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        fCloseModal()
        reset()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky title={xTitle} onClose={() => {
            fCloseModal()
            reset()
          }} />

          <Paper style={{ padding: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h3" >WMS Variance</Typography>
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "45vh" : "30vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                      cursor: "pointer",
                    }}
                    rows={Wmsrows}
                    columns={columnsWms}
                    hideFooter={Wmsrows.length < 100}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h3" >ERP Variance</Typography>
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "45vh" : "30vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                      cursor: "pointer",
                    }}
                    rows={ERProws}
                    columns={columnsErp}
                    hideFooter={ERProws.length < 100}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </Modal>
  );
};

export default PrintModal;
